const defaultState = {
  parameters: {
    jobTitle: null,
    jobLocation: null,
    employmentType: 'any',
    companyName: null,
    contactName: null,
    email: null,
    phoneNumber: null,
    contactOtherAgencies: false,
  },
  loading: true, // Loading agency information
  submitting: false, // Submitting form
  errors: {}, // Validation or Submit errors
  success: false, // Successfully submitted form
  failed: false, // Failed to submit
  agency: false, // The agency selected for a callback
};
const mutations = {
  setParameter(state, { key, value }) {
    state.parameters[key] = value;
    if (state.errors[key]) {
      delete state.errors[key];
    }
  },
  setAgency(state, agency) {
    state.agency = agency;
  },
  setLoading(state, loading = true) {
    state.loading = loading;
  },
  setSubmitting(state, submitting = true) {
    state.submitting = submitting;
  },
  setFailed(state, failed = true) {
    state.failed = failed;
  },
  resetState(state) {
    state = {
      ...defaultState,
    };
  },
  setErrors(state, errors) {
    state.errors = errors;
  },
  setSuccess(state, success = true) {
    state.success = success;
  },
};
const actions = {
  async submitEmployerCallbackForm({ state, commit }) {
    if (state.submitting) {
      return;
    }
    commit('setSubmitting');

    const response = await fetch('/api/employerCallbackSubmit', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ ...state.parameters }),
    });

    if (!response.ok) {
      commit('setSuccess', false);

      if (response.status === 422) {
        // Laravel Validation Errors
        const responseErrors = (await response.json()).errors ?? {};
        commit('setErrors', responseErrors);
      } else {
        // Other Errors
        commit('setFailed');
      }

      commit('setSubmitting', false);
      return;
    }

    commit('setSuccess');
    commit('setErrors', {});
    commit('setSubmitting', false);
  },
};
export default {
  namespaced: true,
  actions,
  mutations,
  state: defaultState,
};
